import * as React from 'react';

function IrLiftFloorsIcon({ color = '#545454', ...props }) {
	return (
		<svg width={18} height={18} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M17.0837 15.1987H13.6924C13.6924 11.8074 17.0837 12.6552 17.0837 10.1117C17.0837 8.83995 15.388 7.99212 13.6924 9.26387'
				stroke={color}
				stroke-width='2'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<path
				d='M10.7653 15.1986L7.70898 15.1982L7.70898 8.72376'
				stroke={color}
				stroke-width='2'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<path
				d='M3.64453 5.96558L3.64453 18.0346C3.64453 19.0601 4.47584 19.8914 5.5013 19.8914L18.4987 19.8914C19.5242 19.8914 20.3555 19.0601 20.3555 18.0346L20.3555 5.96558C20.3555 4.94011 19.5242 4.10881 18.4987 4.10881L5.5013 4.10881C4.47584 4.10881 3.64453 4.94011 3.64453 5.96558Z'
				stroke={color}
				stroke-width='2'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<rect x='15.3916' y='0.994141' width='7.80462' height='7.64024' rx='1.5' fill={color} />
			<path
				d='M17.711 2.41232V6.99414H16.7423V2.41232H17.711ZM18.508 6.99414V2.41232H20.3156C20.6617 2.41232 20.957 2.47422 21.2016 2.59801C21.4477 2.72031 21.6349 2.89407 21.7631 3.11928C21.8929 3.343 21.9578 3.60625 21.9578 3.90902C21.9578 4.21328 21.8921 4.47504 21.7609 4.69428C21.6296 4.91204 21.4395 5.07908 21.1904 5.19542C20.9428 5.31175 20.643 5.36992 20.291 5.36992H19.0807V4.59137H20.1344C20.3194 4.59137 20.473 4.56602 20.5953 4.51531C20.7176 4.4646 20.8086 4.38853 20.8682 4.28711C20.9294 4.18569 20.96 4.05966 20.96 3.90902C20.96 3.75689 20.9294 3.62862 20.8682 3.52422C20.8086 3.41982 20.7169 3.34077 20.5931 3.28707C20.4708 3.23189 20.3164 3.2043 20.13 3.2043H19.4767V6.99414H18.508ZM20.9823 4.90906L22.1211 6.99414H21.0517L19.9376 4.90906H20.9823Z'
				fill={color === 'white' ? '#545454' : 'white'}
			/>
		</svg>
	);
}

export default IrLiftFloorsIcon;
